import React from 'react';
import PropTypes from 'prop-types';

import './Form.scss';

const Label = (
  {
    forInput,
    id,
    children,
    dangerouslySetInnerHTML: { __html: translation },
    required,
  }
/* eslint-disable-next-line jsx-a11y/label-has-associated-control, jsx-a11y/label-has-for */
) => <label id={id} className={required ? 'Label required' : 'Label'} htmlFor={forInput}>{translation || children}</label>;

Label.propTypes = {
  children: PropTypes.node.isRequired,
  dangerouslySetInnerHTML: PropTypes.shape({
    __html: PropTypes.string,
  }),
  forInput: PropTypes.string,
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  required: PropTypes.bool,
};

Label.defaultProps = {
  dangerouslySetInnerHTML: {},
  forInput: null,
  id: null,
  required: false,
};

export default Label;
